
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { replace, concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import Calendar_Warning from "../../public/assets/icons/Calendar_Warning.svg";
import { filter, choose, truncate, isEmpty, empty as empty_1, toArray, exists, take, length, map, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { BlockHeader, TextValue } from "../Components/Text.js";
import { toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { useTranslation } from "react-i18next";
import { TextButton } from "../Components/Button.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { unwrapConsumableId, unwrapToolId } from "../Shared/Helper.js";
import { StocktakingId__get_unwrap, SetId__get_unwrap, ToolId__get_unwrap, ProblemReportId__get_unwrap } from "../Shared/Shared.js";
import { Helper_unitToTranslationKey } from "../Shared/Consumable.js";
import { unwrap, map as map_1, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { resolve, useDefinitions } from "../InventoryStates/Display.js";
import { InventoryBaseState } from "../Shared/InventoryStates.js";
import { ColoredDot } from "../Components/ColoredDot.js";
import { StocktakingState__ToI18nString } from "../Shared/Stocktaking.js";
import { canSeeLocations, canSeeStocktakings, canSeeTelematics, usePermissions } from "../UserPermissions.js";
import { isAvailable as isAvailable_1 } from "../Telematics/Feature.js";
import { useTrackersIf } from "../Requests/Telematics.js";
import { Hooks_useLocationsIf } from "../Requests/Location.js";
import { DashboardSkeleton, EditableBlock, EditToolbar, CustomizeButton, gridClasses, blockAttributes, GridItem, BlockContent } from "./Layout.js";
import { OpenNotificationsCard } from "./OpenNotification.js";
import { TrackerMapCard } from "../Telematics/Trackers/MapCard.js";
import { DashboardBlockModule_key } from "../Shared/DashboardConfiguration.js";
import { ConfirmationDialog } from "../Components/Dialog.js";
import { Msg } from "./Types.js";
import { SWR_getDashboard } from "../Requests/Dashboard.js";
import { useSWRConfig } from "swr";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { DashboardDto } from "../Shared/DashboardOverview.js";

function DateWithIcon(props) {
    let elems_3;
    return reactElement("div", createObj(singleton_1((elems_3 = toList(delay(() => {
        let elems_2;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-2"])], (elems_2 = toList(delay(() => {
            let elems;
            return append(props.IsOverdue ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["text-red", "h-4", "w-4", "self-center"])], (elems = [Calendar_Warning()], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => {
                let elems_1;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => ((!props.IsOverdue && props.HasOverdueInColumn) ? singleton("ml-6") : empty()))))], (elems_1 = [createElement(TextValue, {
                    FontWeight: "small",
                    TestId: "",
                    Text: toString(toLocalTime(props.Date), "dd.MM.yyyy"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            const matchValue = props.SecondRow;
            return (matchValue == null) ? singleton(defaultOf()) : singleton(matchValue);
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))]))));
}

function ProblemReportsCard(props) {
    let elems_5;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_5 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("dashboard.problem_reports"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.date"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.description"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let problems;
                return append(map((problem) => {
                    let elems_3, elems_2;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mt-2", "pb-2", "border-border", "border-b"])], (elems_3 = [createElement(DateWithIcon, {
                        Date: problem.Date,
                        HasOverdueInColumn: false,
                        IsOverdue: false,
                        SecondRow: createElement(TextButton, {
                            ComponentState: "enabled",
                            Label: problem.SenderName,
                            OnClick: () => {
                                RouterModule_nav(ofArray(["receivers", problem.SenderId]), 1, 1);
                            },
                            TestId: "",
                            Variant: "blueButton",
                        }),
                    }), createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: problem.Description,
                    }), reactElement("div", createObj(singleton_1((elems_2 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: problem.ToolTitle,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["tools", unwrapToolId(problem.ToolId) + RouterModule_encodeQueryString(singleton_1(["problemReportId", ProblemReportId__get_unwrap(problem.ProblemReportId)]))]), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: problem.ToolSubtitle,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["tools", unwrapToolId(problem.ToolId) + RouterModule_encodeQueryString(singleton_1(["problemReportId", ProblemReportId__get_unwrap(problem.ProblemReportId)]))]), 1, 1);
                        },
                        TestId: "",
                        Variant: "default",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
                }, (problems = props.Problems, (length(problems) > 5) ? take(5, problems) : problems)), delay(() => {
                    let elems_4;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_4 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "problemreports"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function ReminderCard(props) {
    let elems_6;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_6 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("general.appointments"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.designation"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("dashboard.assigned_to"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let reminders;
                return append(map((reminder) => {
                    let elems_4, elems_2, elems_3;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mt-2", "pb-2", "border-border", "border-b"])], (elems_4 = [createElement(DateWithIcon, {
                        Date: reminder.Date,
                        HasOverdueInColumn: false,
                        IsOverdue: reminder.IsOverdue,
                        SecondRow: createElement(TextValue, {
                            FontWeight: "small",
                            TestId: "",
                            Text: reminder.Description,
                        }),
                    }), reactElement("div", createObj(singleton_1((elems_2 = toList(delay(() => {
                        const matchValue = reminder.CurrentAssignment;
                        if (matchValue == null) {
                            return singleton(defaultOf());
                        }
                        else {
                            const matchValue_1 = matchValue;
                            if (matchValue_1.tag === 0) {
                                return singleton(createElement(TextValue, {
                                    FontWeight: "small",
                                    TestId: "",
                                    Text: matchValue_1.fields[0],
                                }));
                            }
                            else {
                                const receiver = matchValue_1.fields[0];
                                return singleton(createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: receiver.ReceiverName,
                                    OnClick: () => {
                                        RouterModule_nav(ofArray(["receivers", receiver.ReceiverId]), 1, 1);
                                    },
                                    TestId: "",
                                    Variant: "blueButton",
                                }));
                            }
                        }
                    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])))), reactElement("div", createObj(singleton_1((elems_3 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: reminder.ToolTitle,
                        OnClick: () => {
                            const matchValue_2 = reminder.ReminderDateInfoType;
                            switch (matchValue_2.tag) {
                                case 0: {
                                    RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue_2.fields[0])]), 1, 1);
                                    break;
                                }
                                case 1: {
                                    RouterModule_nav(ofArray(["toolswithquantity", ToolId__get_unwrap(matchValue_2.fields[0])]), 1, 1);
                                    break;
                                }
                                case 2: {
                                    RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue_2.fields[0])]), 1, 1);
                                    break;
                                }
                                default:
                                    RouterModule_nav(ofArray(["consumables", unwrapConsumableId(matchValue_2.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: reminder.ToolSubtitle,
                        OnClick: () => {
                            const matchValue_3 = reminder.ReminderDateInfoType;
                            switch (matchValue_3.tag) {
                                case 0: {
                                    RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue_3.fields[0])]), 1, 1);
                                    break;
                                }
                                case 1: {
                                    RouterModule_nav(ofArray(["toolswithquantity", ToolId__get_unwrap(matchValue_3.fields[0])]), 1, 1);
                                    break;
                                }
                                case 2: {
                                    RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue_3.fields[0])]), 1, 1);
                                    break;
                                }
                                default:
                                    RouterModule_nav(ofArray(["consumables", unwrapConsumableId(matchValue_3.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "default",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
                }, (reminders = props.ReminderDates, (length(reminders) > 5) ? take(5, reminders) : reminders)), delay(() => {
                    let elems_5;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_5 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "appointments"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

function MinimumQuantityCard(props) {
    let elems_5;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_5 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("dashboard.minimum_stock"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-5", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.stock"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.minimum_quantity"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.unit"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.storage"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let reminders;
                return append(map((reminder) => {
                    let elems_3, elems_2;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-5", "mt-2", "pb-2", "border-border", "border-b"])], (elems_3 = [createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: (reminder.tag === 1) ? reminder.fields[0].CurrentStock : ((reminder.tag === 2) ? reminder.fields[0].CurrentStock : reminder.fields[0].CurrentStock),
                    }), createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: (reminder.tag === 1) ? reminder.fields[0].MinimumQuantityStock : ((reminder.tag === 2) ? reminder.fields[0].MinimumQuantityStock : reminder.fields[0].MinimumQuantityStock),
                    }), createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: (reminder.tag === 1) ? t("unit.piece") : ((reminder.tag === 2) ? t("unit.piece") : t(Helper_unitToTranslationKey(reminder.fields[0].Unit))),
                    }), createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: (reminder.tag === 1) ? reminder.fields[0].StorageName : ((reminder.tag === 2) ? reminder.fields[0].StorageName : reminder.fields[0].StorageName),
                    }), reactElement("div", createObj(singleton_1((elems_2 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: (reminder.tag === 1) ? reminder.fields[0].DisplayName : ((reminder.tag === 2) ? reminder.fields[0].DisplayName : reminder.fields[0].DisplayName),
                        OnClick: () => {
                            switch (reminder.tag) {
                                case 1: {
                                    RouterModule_nav(ofArray(["toolswithquantity", unwrapToolId(reminder.fields[0].Id)]), 1, 1);
                                    break;
                                }
                                case 2: {
                                    const inventoryTranslation = t("general.tool");
                                    const setTranslation = t("general.set");
                                    RouterModule_nav(ofArray(["tools", concat("?isToolWithQuantity=", window.encodeURIComponent(concat(inventoryTranslation, ",", ...setTranslation)), "&label=", ...reminder.fields[0].DisplayName)]), 1, 1);
                                    break;
                                }
                                default:
                                    RouterModule_nav(ofArray(["consumables", unwrapConsumableId(reminder.fields[0].Id)]), 1, 1);
                            }
                        },
                        TestId: "dashboard-minimum-stock-entry-test-id",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
                }, (reminders = props.MinimumQuantityReminders, (length(reminders) > 5) ? take(5, reminders) : reminders)), delay(() => {
                    let elems_4;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_4 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "minimumstockquantity"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function PlannedReturnDateCard(props) {
    let elems_6;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_6 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("dashboard.tool_return_date_title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.date"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.user"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let returnDates;
                return append(map((returnDate) => {
                    let elems_4, elems_2, elems_3;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mt-2", "pb-2", "border-border", "border-b"])], (elems_4 = [createElement(DateWithIcon, {
                        Date: returnDate.ReturnDate,
                        HasOverdueInColumn: exists((_arg) => _arg.IsOverdue, props.ToolReturnDates),
                        IsOverdue: returnDate.IsOverdue,
                    }), reactElement("div", createObj(singleton_1((elems_2 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: returnDate.ReceiverName,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["receivers", returnDate.ReceiverId]), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])))), reactElement("div", createObj(singleton_1((elems_3 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: returnDate.Title,
                        OnClick: () => {
                            const matchValue = returnDate.Id;
                            if (matchValue.tag === 1) {
                                RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue.fields[0])]), 1, 1);
                            }
                            else {
                                RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: returnDate.Subtitle,
                        OnClick: () => {
                            const matchValue_1 = returnDate.Id;
                            if (matchValue_1.tag === 1) {
                                RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                            }
                            else {
                                RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "default",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
                }, (returnDates = props.ToolReturnDates, (length(returnDates) > 5) ? take(5, returnDates) : returnDates)), delay(() => {
                    let elems_5;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_5 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "plannedreturndate"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

function ReleaseDateCard(props) {
    let elems_5;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_5 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("dashboard.release_dates"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.date"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.user"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let releaseDates;
                return append(map((releaseDate) => {
                    let elems_3, elems_2;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mt-2", "pb-2", "border-border", "border-b"])], (elems_3 = [createElement(DateWithIcon, {
                        Date: releaseDate.ReleaseDate,
                        HasOverdueInColumn: exists((_arg) => _arg.IsOverdue, props.ReleaseDates),
                        IsOverdue: releaseDate.IsOverdue,
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: releaseDate.ReceiverName,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["receivers", releaseDate.ReceiverId]), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), reactElement("div", createObj(singleton_1((elems_2 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: releaseDate.Title,
                        OnClick: () => {
                            const matchValue = releaseDate.Id;
                            if (matchValue.tag === 1) {
                                RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue.fields[0])]), 1, 1);
                            }
                            else {
                                RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: releaseDate.Subtitle,
                        OnClick: () => {
                            const matchValue_1 = releaseDate.Id;
                            if (matchValue_1.tag === 1) {
                                RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                            }
                            else {
                                RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "default",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
                }, (releaseDates = props.ReleaseDates, (length(releaseDates) > 5) ? take(5, releaseDates) : releaseDates)), delay(() => {
                    let elems_4;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_4 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "releasedates"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function NextReservationCard(props) {
    let elems_4;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_4 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("dashboard.tool_next_reservations_title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-6", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.start_date"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.end_date"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.name"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.user"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.quantity"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let reservations;
                return append(map((reservation) => {
                    let elems_2;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-6", "mt-2", "pb-2", "border-border", "border-b"])], (elems_2 = [createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: toString(toLocalTime(reservation.StartDate), "dd.MM.yyyy"),
                    }), createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: toString(toLocalTime(reservation.EndDate), "dd.MM.yyyy"),
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: reservation.Name,
                        OnClick: () => {
                            let matchValue;
                            RouterModule_nav(ofArray(["reservations", (matchValue = reservation.GroupId, (matchValue == null) ? reservation.Id : matchValue)]), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: reservation.ReceiverInformation.ReceiverName,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["receivers", reservation.ReceiverInformation.ReceiverId]), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: reservation.ToolInformation.Name,
                        OnClick: () => {
                            let matchValue_1;
                            RouterModule_nav(ofArray(toArray((matchValue_1 = reservation.ToolInformation.Type, (matchValue_1.tag === 1) ? ofArray(["toolswithquantity", reservation.ToolInformation.Id]) : ((matchValue_1.tag === 2) ? ofArray(["consumables", reservation.ToolInformation.Id]) : ((matchValue_1.tag === 3) ? ofArray(["sets", reservation.ToolInformation.Id]) : ((matchValue_1.tag === 4) ? ofArray(["reservations", defaultArg(reservation.GroupId, "")]) : ofArray(["tools", reservation.ToolInformation.Id]))))))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: defaultArg(reservation.ToolInformation.Quantity, ""),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
                }, (reservations = props.ReservationInfos, (length(reservations) > 5) ? take(5, reservations) : reservations)), delay(() => {
                    let elems_3;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_3 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "reservations"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function InMaintenanceCard(props) {
    let elems_6;
    const t = useTranslation()[0];
    const definitions = useDefinitions();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_6 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("general.in_maintenance"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.date"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.user"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let maintenanceInfos;
                return append(map((row_1) => {
                    let elems_4, elems_2, elems_3;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mt-2", "pb-2", "border-border", "border-b"])], (elems_4 = [createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: toString(toLocalTime(row_1.Date), "dd.MM.yyyy"),
                    }), reactElement("div", createObj(singleton_1((elems_2 = toList(delay(() => append(singleton(createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: row_1.Title,
                        OnClick: () => {
                            const matchValue = row_1.ToolInfoType;
                            if (matchValue.tag === 1) {
                                RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue.fields[0])]), 1, 1);
                            }
                            else {
                                RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })), delay(() => append(singleton(createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: row_1.Subtitle,
                        OnClick: () => {
                            const matchValue_1 = row_1.ToolInfoType;
                            if (matchValue_1.tag === 1) {
                                RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                            }
                            else {
                                RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "default",
                    })), delay(() => {
                        let matchValue_2;
                        const definition = resolve(definitions, row_1.StateKey, new InventoryBaseState(1, []));
                        matchValue_2 = (definition.IsSystem ? undefined : definition.Name);
                        if (matchValue_2 == null) {
                            return singleton(defaultOf());
                        }
                        else {
                            const name_2 = matchValue_2;
                            return singleton(createElement(TextValue, {
                                FontWeight: "small",
                                TestId: concat("dashboard-in-maintenance-state-", ...row_1.StateKey),
                                Text: name_2,
                            }));
                        }
                    })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])))), reactElement("div", createObj(singleton_1((elems_3 = toList(delay(() => {
                        const matchValue_3 = row_1.CurrentAssignment;
                        if (matchValue_3 == null) {
                            return singleton(defaultOf());
                        }
                        else {
                            const matchValue_4 = matchValue_3;
                            if (matchValue_4.tag === 0) {
                                return singleton(createElement(TextValue, {
                                    FontWeight: "small",
                                    TestId: "",
                                    Text: matchValue_4.fields[0],
                                }));
                            }
                            else {
                                const receiver = matchValue_4.fields[0];
                                return singleton(createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: receiver.ReceiverName,
                                    OnClick: () => {
                                        RouterModule_nav(ofArray(["receivers", receiver.ReceiverId]), 1, 1);
                                    },
                                    TestId: "",
                                    Variant: "blueButton",
                                }));
                            }
                        }
                    })), ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
                }, (maintenanceInfos = props.InInMaintenanceInfos, (length(maintenanceInfos) > 5) ? take(5, maintenanceInfos) : maintenanceInfos)), delay(() => {
                    let elems_5;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_5 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "in_maintenance"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

function InspectionStatusCard(props) {
    let elems_13;
    const t = useTranslation()[0];
    const upcomingInspections = (props.InspectionStatus.UpcomingInspections == null) ? empty_1() : props.InspectionStatus.UpcomingInspections;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_13 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(singleton_1((elems = [createElement(BlockHeader, {
            Text: t("dashboard.inspection_status_title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))]))))), delay(() => {
            let elems_5, elems_1, elems_2, elems_3, elems_4;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-3", "mt-4"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-[#EFFEF4]", "rounded-lg", "p-4", "text-center"])], (elems_1 = [reactElement("div", {
                className: join(" ", ["text-sm", "text-[#1E6939]", "mb-1"]),
                children: t("dashboard.inspection_status_ok"),
            }), reactElement("div", {
                className: join(" ", ["text-2xl", "font-bold", "text-[#1E6939]"]),
                children: int32ToString(props.InspectionStatus.InspectedCount),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-[#FEFCE8]", "rounded-lg", "p-4", "text-center"])], (elems_2 = [reactElement("div", {
                className: join(" ", ["text-sm", "text-[#854E0E]", "mb-1"]),
                children: t("dashboard.inspection_status_expired"),
            }), reactElement("div", {
                className: join(" ", ["text-2xl", "font-bold", "text-[#854E0E]"]),
                children: int32ToString(props.InspectionStatus.ExpiredCount),
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-light-red", "rounded-lg", "p-4", "text-center"])], (elems_3 = [reactElement("div", {
                className: join(" ", ["text-sm", "text-[#981B1B]", "mb-1"]),
                children: t("dashboard.inspection_status_never_inspected"),
            }), reactElement("div", {
                className: join(" ", ["text-2xl", "font-bold", "text-[#981B1B]"]),
                children: int32ToString(props.InspectionStatus.NeverInspectedCount),
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-light-red", "rounded-lg", "p-4", "text-center"])], (elems_4 = [reactElement("div", {
                className: join(" ", ["text-sm", "text-[#981B1B]", "mb-1"]),
                children: t("dashboard.inspection_status_failed"),
            }), reactElement("div", {
                className: join(" ", ["text-2xl", "font-bold", "text-[#981B1B]"]),
                children: int32ToString(props.InspectionStatus.FailedCount),
            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                let elems_6;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-4"])], (elems_6 = [createElement(TextButton, {
                    ComponentState: "enabled",
                    Label: t("dashboard.to_reports"),
                    OnClick: () => {
                        RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "uninspectedtools"]))), 1, 1);
                    },
                    TestId: "",
                    Variant: "blueButton",
                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                    let elems_7;
                    return !isEmpty(upcomingInspections) ? append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_7 = [createElement(BlockHeader, {
                        Text: t("dashboard.upcoming_inspections_title"),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                        let elems_8;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mb-2", "border-border", "border-b-2"])], (elems_8 = [createElement(TextValue, {
                            FontWeight: "small",
                            TestId: "",
                            Text: t("general.designation"),
                        }), createElement(TextValue, {
                            FontWeight: "small",
                            TestId: "",
                            Text: t("dashboard.assigned_to"),
                        }), createElement(TextValue, {
                            FontWeight: "small",
                            TestId: "",
                            Text: t("general.tool"),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                            let upcomingInspections_1;
                            return append(map((upcomingInspection) => {
                                let elems_11, elems_9, elems_10;
                                return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mt-2", "pb-2", "border-border", "border-b"])], (elems_11 = [createElement(DateWithIcon, {
                                    Date: upcomingInspection.Date,
                                    HasOverdueInColumn: false,
                                    IsOverdue: upcomingInspection.IsOverdue,
                                    SecondRow: createElement(TextValue, {
                                        FontWeight: "small",
                                        TestId: "",
                                        Text: upcomingInspection.TemplateName,
                                    }),
                                }), reactElement("div", createObj(singleton_1((elems_9 = toList(delay(() => {
                                    const matchValue = upcomingInspection.CurrentAssignment;
                                    if (matchValue == null) {
                                        return singleton(defaultOf());
                                    }
                                    else {
                                        const matchValue_1 = matchValue;
                                        if (matchValue_1.tag === 0) {
                                            return singleton(createElement(TextValue, {
                                                FontWeight: "small",
                                                TestId: "",
                                                Text: matchValue_1.fields[0],
                                            }));
                                        }
                                        else {
                                            const receiver = matchValue_1.fields[0];
                                            return singleton(createElement(TextButton, {
                                                ComponentState: "enabled",
                                                Label: receiver.ReceiverName,
                                                OnClick: () => {
                                                    RouterModule_nav(ofArray(["receivers", receiver.ReceiverId]), 1, 1);
                                                },
                                                TestId: "",
                                                Variant: "blueButton",
                                            }));
                                        }
                                    }
                                })), ["children", reactApi.Children.toArray(Array.from(elems_9))])))), reactElement("div", createObj(singleton_1((elems_10 = [createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: upcomingInspection.ToolTitle,
                                    OnClick: () => {
                                        RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(upcomingInspection.ToolId)]), 1, 1);
                                    },
                                    TestId: "",
                                    Variant: "blueButton",
                                }), createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: upcomingInspection.ToolSubtitle,
                                    OnClick: () => {
                                        RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(upcomingInspection.ToolId)]), 1, 1);
                                    },
                                    TestId: "",
                                    Variant: "default",
                                })], ["children", reactApi.Children.toArray(Array.from(elems_10))]))))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])));
                            }, (upcomingInspections_1 = upcomingInspections, (length(upcomingInspections_1) > 5) ? take(5, upcomingInspections_1) : upcomingInspections_1)), delay(() => {
                                let elems_12;
                                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_12 = [createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: t("dashboard.to_reports"),
                                    OnClick: () => {
                                        RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "inspectioncalendar"]))), 1, 1);
                                    },
                                    TestId: "",
                                    Variant: "blueButton",
                                })], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))));
                            }));
                        }));
                    })) : empty();
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
}

function AvailabilityViewCounts(props) {
    let elems_3, elems_1, elems_2;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_3 = [reactElement("div", {
        className: join(" ", ["text-sm", "text-text-muted"]),
        children: replace(t("availability.period_next_days"), "{{days}}", int32ToString(props.View.PeriodDays)) + (` (${toString(props.View.StartDate, "dd.MM.yyyy")} – ${toString(props.View.EndDate, "dd.MM.yyyy")})`),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-6"])], (elems_1 = map((tupledArg) => {
        let elems;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2"])], (elems = [createElement(ColoredDot, {
            Color: tupledArg[0],
        }), reactElement("span", {
            className: join(" ", ["text-2xl", "font-semibold"]),
            children: int32ToString(tupledArg[1]),
        }), reactElement("span", {
            className: join(" ", ["text-sm"]),
            children: tupledArg[2],
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, ofArray([["green", props.View.AvailableCount, t("availability.status_available")], ["orange", props.View.PartiallyAvailableCount, t("availability.status_partially_available")], ["red", props.View.UnavailableCount, t("availability.status_unavailable")]])), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems_2 = [createElement(TextButton, {
        ComponentState: "enabled",
        Label: t("dashboard.availability_details"),
        OnClick: () => {
            RouterModule_nav(singleton_1("availability" + RouterModule_encodeQueryString(singleton_1(["view", props.View.Name]))), 1, 1);
        },
        TestId: "dashboard-availability-details-test-id",
        Variant: "blueButton",
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function AvailabilityCard(props) {
    let elems_3, elems, elems_2;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
        Text: patternInput[0]("dashboard.availability_title"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-6"])], (elems_2 = map((view) => {
        let elems_1;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_1 = [reactElement("div", {
            className: join(" ", ["font-bold"]),
            children: view.Name,
        }), createElement(AvailabilityViewCounts, {
            View: view,
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }, props.Views), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function RunningStocktakingsCard(props) {
    let elems_4;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const formatDate = (date) => toString(date, "dd.MM.yyyy");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_4 = toList(delay(() => append(singleton(createElement(BlockHeader, {
        Text: "dashboard.running_stocktakings",
    })), delay(() => append(map((stocktaking_1) => {
        let elems_2, elems, Text$, elems_1, Text$_1, stocktaking, arg_1, Text$_2;
        const id = StocktakingId__get_unwrap(stocktaking_1.Id);
        return reactElement("div", createObj(ofArray([["data-test-id", concat("dashboard-stocktaking-", ...id)], ["className", join(" ", ["flex", "flex-col", "gap-1", "mt-2", "pb-2", "border-border", "border-b"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "items-start", "gap-2"])], (elems = [createElement(TextButton, {
            ComponentState: "enabled",
            Label: stocktaking_1.Name,
            OnClick: () => {
                RouterModule_nav(ofArray(["stocktaking", id]), 1, 1);
            },
            TestId: concat("dashboard-stocktaking-name-", ...id),
            Variant: "blueButton",
        }), createElement(TextValue, (Text$ = t(StocktakingState__ToI18nString(stocktaking_1.State)), {
            FontWeight: "small",
            TestId: concat("dashboard-stocktaking-state-", ...id),
            Text: Text$,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", {
            className: join(" ", ["text-sm", "text-text-muted"]),
            "data-test-id": concat("dashboard-stocktaking-responsible-", ...id),
            children: concat(t("stocktaking.responsible_person"), ": ", ...join(", ", stocktaking_1.ResponsiblePersons)),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "gap-2"])], (elems_1 = [createElement(TextValue, (Text$_1 = ((stocktaking = stocktaking_1, (stocktaking.TotalPositions === 0) ? "–" : ((arg_1 = {
            counted: stocktaking.CountedPositions,
            total: stocktaking.TotalPositions,
        }, patternInput[1].t("stocktaking.counting.progress", arg_1))))), {
            FontWeight: "small",
            TestId: concat("dashboard-stocktaking-progress-", ...id),
            Text: Text$_1,
        })), createElement(TextValue, (Text$_2 = concat(formatDate(stocktaking_1.StartDate), " – ", ...formatDate(stocktaking_1.EndDate)), {
            FontWeight: "small",
            TestId: concat("dashboard-stocktaking-period-", ...id),
            Text: Text$_2,
        }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
    }, truncate(5, props.Stocktakings)), delay(() => {
        let elems_3;
        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_3 = [createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("dashboard.to_stocktakings"),
            OnClick: () => {
                RouterModule_nav(ofArray(["stocktaking"]), 1, 1);
            },
            TestId: "dashboard-stocktakings-overview-link",
            Variant: "blueButton",
        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function Dashboard(props) {
    let elems_2;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const lastMove = reactApi.useRef(0);
    const trackerMapAvailable = isAvailable_1(props.AccountSettings) && canSeeTelematics(permissions);
    const trackers = useTrackersIf(trackerMapAvailable);
    const runningStocktakingsAvailable = props.AccountSettings.InventoryEnabled && canSeeStocktakings(permissions);
    const trackerMapConnected = defaultArg(map_1((_arg) => _arg.Connected, trackers.data), false);
    const hasLocationMarkers = exists((location) => {
        if (!location.IsDeleted) {
            return location.Coordinates != null;
        }
        else {
            return false;
        }
    }, defaultArg(Hooks_useLocationsIf(canSeeLocations(permissions)).data, empty_1()));
    const contentOf = (block) => {
        switch (block.tag) {
            case 1:
                if (isEmpty(props.Dashboard.Data.OpenNotifications)) {
                    return new BlockContent(1, []);
                }
                else {
                    return new BlockContent(2, [createElement(OpenNotificationsCard, {
                        Dispatch: props.Dispatch,
                        FormState: props.State.FormState,
                        NotificationToDelete: unwrap(props.State.NotificationToDelete),
                        OpenNotifications: props.Dashboard.Data.OpenNotifications,
                    })]);
                }
            case 2: {
                const matchValue = props.Dashboard.RunningStocktakings;
                if (!runningStocktakingsAvailable) {
                    return new BlockContent(0, []);
                }
                else if (isEmpty(matchValue)) {
                    return new BlockContent(1, []);
                }
                else {
                    return new BlockContent(2, [createElement(RunningStocktakingsCard, {
                        Stocktakings: matchValue,
                    })]);
                }
            }
            case 3: {
                const matchValue_1 = props.Dashboard.Data.InspectionStatus;
                if (matchValue_1 == null) {
                    return new BlockContent(1, []);
                }
                else {
                    return new BlockContent(2, [createElement(InspectionStatusCard, {
                        InspectionStatus: matchValue_1,
                    })]);
                }
            }
            case 4:
                return new BlockContent(2, [createElement(ProblemReportsCard, {
                    Problems: props.Dashboard.Data.Problems,
                })]);
            case 5:
                return new BlockContent(2, [createElement(InMaintenanceCard, {
                    InInMaintenanceInfos: props.Dashboard.Data.InMaintenanceToolsAndSets,
                })]);
            case 6:
                return new BlockContent(2, [createElement(ReminderCard, {
                    ReminderDates: props.Dashboard.Data.ReminderDates,
                })]);
            case 7: {
                const matchValue_2 = props.Dashboard.AvailabilityViews;
                if (isEmpty(matchValue_2)) {
                    return new BlockContent(1, []);
                }
                else {
                    return new BlockContent(2, [createElement(AvailabilityCard, {
                        Views: matchValue_2,
                    })]);
                }
            }
            case 8:
                return new BlockContent(2, [createElement(PlannedReturnDateCard, {
                    ToolReturnDates: props.Dashboard.Data.ToolReturnDates,
                })]);
            case 9:
                return new BlockContent(2, [createElement(MinimumQuantityCard, {
                    MinimumQuantityReminders: props.Dashboard.Data.MinimumQuantityReminder,
                })]);
            case 10:
                return new BlockContent(2, [createElement(NextReservationCard, {
                    ReservationInfos: props.Dashboard.Data.ReservationInfos,
                })]);
            case 11: {
                const matchValue_3 = props.Dashboard.Data.ReleaseDates;
                if (matchValue_3 == null) {
                    return new BlockContent(1, []);
                }
                else {
                    return new BlockContent(2, [createElement(ReleaseDateCard, {
                        ReleaseDates: matchValue_3,
                    })]);
                }
            }
            default:
                if (trackerMapConnected ? true : hasLocationMarkers) {
                    return new BlockContent(2, [createElement(TrackerMapCard, {
                        AccountSettings: props.AccountSettings,
                    })]);
                }
                else if (trackerMapAvailable) {
                    return new BlockContent(1, []);
                }
                else {
                    return new BlockContent(0, []);
                }
        }
    };
    const gridItem = (configuration, children) => {
        const key = DashboardBlockModule_key(configuration.Block);
        const xs = [createElement(GridItem, {
            Attributes: blockAttributes(configuration),
            Children: children,
            Size: configuration.Size,
        })];
        return react.createElement(react.Fragment, {
            key: key,
        }, ...xs);
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = toList(delay(() => {
        let elems_1;
        const matchValue_4 = props.State.Draft;
        if (matchValue_4 == null) {
            const visibleBlocks = choose((configuration_6) => {
                const matchValue_5 = contentOf(configuration_6.Block);
                switch (matchValue_5.tag) {
                    case 1:
                    case 0:
                        return undefined;
                    default:
                        return [configuration_6, matchValue_5.fields[0]];
                }
            }, filter((_arg_5) => _arg_5.Visible, props.Dashboard.Configuration.Blocks));
            return append(isEmpty(visibleBlocks) ? singleton(reactElement("div", {
                "data-test-id": "dashboard-empty",
                className: join(" ", ["bg-white", "p-8", "rounded", "text-sm"]),
                children: t("dashboard.configuration.all_hidden"),
            })) : singleton(reactElement("div", createObj(ofArray([["data-test-id", "dashboard-grid"], ["className", join(" ", gridClasses)], (elems_1 = map((tupledArg_5) => gridItem(tupledArg_5[0], tupledArg_5[1]), visibleBlocks), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => singleton(createElement(CustomizeButton, {
                Blocks: props.Dashboard.Configuration.Blocks,
                Dispatch: props.Dispatch,
            }))));
        }
        else {
            const availableBlocks = filter((tupledArg) => {
                const content = tupledArg[1];
                switch (content.tag) {
                    case 1:
                    case 2:
                        return true;
                    default:
                        return false;
                }
            }, map((configuration_1) => [configuration_1, contentOf(configuration_1.Block)], matchValue_4));
            const editableBlocks = filter((tupledArg_1) => tupledArg_1[0].Visible, availableBlocks);
            return append(singleton(createElement(EditToolbar, {
                Dispatch: props.Dispatch,
                FormState: props.State.FormState,
                HiddenBlocks: map((tupledArg_3) => tupledArg_3[0].Block, filter((tupledArg_2) => !tupledArg_2[0].Visible, availableBlocks)),
            })), delay(() => {
                let elems;
                return append(isEmpty(editableBlocks) ? singleton(reactElement("div", {
                    "data-test-id": "dashboard-empty",
                    className: join(" ", ["bg-white", "p-8", "rounded", "text-sm"]),
                    children: t("dashboard.configuration.all_hidden_editing"),
                })) : singleton(reactElement("div", createObj(ofArray([["data-test-id", "dashboard-grid"], ["className", join(" ", gridClasses)], (elems = map((tupledArg_4) => {
                    const configuration_5 = tupledArg_4[0];
                    return gridItem(configuration_5, createElement(EditableBlock, {
                        ComponentState: props.State.FormState.IsLoading ? "disabled" : "enabled",
                        Configuration: configuration_5,
                        Content: tupledArg_4[1],
                        Dispatch: props.Dispatch,
                        LastMove: lastMove,
                    }));
                }, editableBlocks), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                    let Title;
                    return singleton(createElement(ConfirmationDialog, (Title = t("dashboard.configuration.reset_title"), {
                        Description: t("dashboard.configuration.reset_confirmation"),
                        FormState: props.State.FormState,
                        IsOpen: props.State.IsResetDialogOpen,
                        OnClose: () => {
                            props.Dispatch(new Msg(13, []));
                        },
                        OnConfirm: () => {
                            props.Dispatch(new Msg(14, []));
                        },
                        Title: Title,
                    })));
                }));
            }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function DashboardView(props) {
    const dashboard = SWR_getDashboard();
    const latest = reactApi.useRef(undefined);
    latest.current = dashboard.data;
    const swrConfig = useSWRConfig();
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, (msg, state) => update_1(dashboard.mutate, (configuration) => {
        const matchValue = latest.current;
        if (matchValue == null) {
        }
        else {
            const current = matchValue;
            swrConfig.mutate("/api/dashboard", new DashboardDto(current.Data, configuration, current.AvailabilityViews, current.RunningStocktakings));
        }
    }, msg, state), (_arg, _arg_1) => {
    }), undefined, []);
    const matchValue_1 = dashboard.data;
    if (matchValue_1 == null) {
        return createElement(DashboardSkeleton, null);
    }
    else {
        return createElement(Dashboard, {
            AccountSettings: props.AccountSettings,
            Dashboard: matchValue_1,
            Dispatch: patternInput[1],
            State: patternInput[0],
        });
    }
}

